var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "chat-wrapper" },
      on: {
        dragenter: _vm.dragEnter,
        dragleave: _vm.dragLeave,
        dragover: _vm.dragOver,
        drop: _vm.dropBlock,
        paste: _vm.handleTPaste,
      },
    },
    [
      _vm.showSupsisDriveFilePicker
        ? _c("FilePicker", {
            attrs: { multiple: true },
            on: {
              cancel: function ($event) {
                _vm.showSupsisDriveFilePicker = false
              },
              confirm: _vm.uploadFromSupsisDrive,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showImageEditor
        ? _c("ImageEditor", {
            attrs: { files: _vm.pendingImageFiles },
            on: { close: _vm.closeImageEditor, save: _vm.handleImageSave },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dragMode
        ? _c("FileDragFrame")
        : [
            _vm.showHeader
              ? _c("ChatHeader", {
                  attrs: {
                    contact: _vm.contact,
                    "is-watching": _vm.isWatching(),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.messageSyncRunning
              ? [_c("MessageSkeleton")]
              : [
                  _c("ChatMessageList", {
                    attrs: {
                      contact: _vm.contact,
                      messages: _vm.messages,
                      messageSyncRunning: _vm.messageSyncRunning,
                    },
                    on: {
                      "reply-comment-action": _vm.handleReplyCommentAction,
                    },
                  }),
                ],
            _vm._v(" "),
            _c("ChatMessageArea", {
              ref: "messageArea",
              attrs: {
                contact: _vm.contact,
                messageSyncRunning: _vm.messageSyncRunning,
                visitorTypingMessage: _vm.visitorTypingMessage,
                "media-uploading": _vm.uploading,
                messages: _vm.messages,
              },
              on: {
                message: function ($event) {
                  return _vm.$emit("message", $event)
                },
                "media-message": _vm.sendMediaMessage,
                "upload-file": _vm.openUploadFromSupsis,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }